import { environmentService, userService, postRequestHandler, getRequestHandler } from "@/utils/services";
import { compressToUTF16 as compress, decompressFromUTF16 as decompress }  from 'lz-string';

let apiUrl = environmentService.apiUrlGeneral;
let apiUrlHotel = environmentService.apiUrlHotel;
let headers = {headers:userService.authHeader()};

export const hotelService = {
  uploadImage,
  deleteImage,

  getHotels,
  getHotelsByToken,
  getHotelsByIds,
  getCategories,
  getAmmenities,

  createHotelInformation,
  updateHotelInformation,

  updateAmmenitiesInformation,

  createPoliciesInformation,
  updatePoliciesInformation,
  deletePoliciesInformation,

  createHotelContact,
  updateHotelContact,
  deleteHotelContact,

  createRoomType,
  updateRoomType,
  getRoomTypesByHotel,

  getMarkupByHotel,
  createMarkupByHotel,
  deleteMarkupByHotel
};

//HOTEL METHODS
async function uploadImage(formData){
  return await commit('setUpdateHotelFinished', true);postRequestHandler(`${apiUrlHotel}/hotels/images/create`, formData, headersWithFile);
}

async function deleteImage(delImgIds){
  return await postRequestHandler(`${apiUrlHotel}/hotels/images/delete`, delImgIds, headers);
}

async function createHotelInformation(hotel){
  return await postRequestHandler(`${apiUrlHotel}/hotels/create`, hotel, headers);
}

async function updateHotelInformation(hotel){
  return await postRequestHandler(`${apiUrlHotel}/hotels/update`, hotel, headers);
}

//AMMENITIES METHODS
async function updateAmmenitiesInformation(ammenitiesIds){
  return await postRequestHandler(`${apiUrlHotel}/hotels/ammenities/update`, ammenitiesIds, headers);
}

//POLICIES METHODS
async function createPoliciesInformation(policy){
  return await postRequestHandler(`${apiUrlHotel}/hotels/policies/create`, policy, headers);
}

async function updatePoliciesInformation(policy){
  return await postRequestHandler(`${apiUrlHotel}/hotels/policies/update`, policy, headers);
}

async function deletePoliciesInformation(policy){
  return await postRequestHandler(`${apiUrlHotel}/hotels/policies/delete`, policy, headers);
}

//CONTACTS METHODS
async function createHotelContact(policy){
  return await postRequestHandler(`${apiUrlHotel}/hotels/contacts/create`, policy, headers);
}

async function updateHotelContact(policy){
  return await postRequestHandler(`${apiUrlHotel}/hotels/contacts/update`, policy, headers);
}

async function deleteHotelContact(contact){
  return await postRequestHandler(`${apiUrlHotel}/hotels/contacts/delete`, contact, headers);
}

// ROOMTYPE METHODS
async function createRoomType(roomType){
  return await postRequestHandler(`${apiUrlHotel}/roomtypes/create`, roomType, headers);
}

async function updateRoomType(roomType){
  updateRoomType = {
    hotel_id : roomType.hotel_id,
    roomtypeId : roomType.roomtypeId,
    name : roomType.name,
    description : roomType.description,
    guests : roomType.guests,
    additionals : roomType.additionals,
  };

  return await postRequestHandler(`${apiUrlHotel}/roomtypes/update`, updateRoomType, headers);
}

//GETTERS
async function getAmmenities(){  //done
  var ammenities = null;
  if (localStorage.getItem(`ammenities`)) {
    ammenities = JSON.parse(decompress(localStorage.getItem(`ammenities`)));
  }
  if (ammenities && ammenities.length > 0) {
    return await ammenities;
  } else {
    return await getRequestHandler(`${apiUrlHotel}/ammenities`, headers);
  }
}

async function getHotels () { //done
  var url = "";
  var user = JSON.parse(decompress(localStorage.getItem(`user`)));
  if(user.role.name == "Hotel"){
    url = `${apiUrlHotel}/hotels/user`;
  }else{
    url = `${apiUrlHotel}/hotels`;
  }
  return await getRequestHandler(url, headers);
}

async function getHotelsByToken () {//done
  return await getRequestHandler(`${apiUrlHotel}/hotels/user`, headers);
}

async function getHotelsByIds (hotelsIds) { // not used
  var jsonHotelsIds = {hotelIds: []};
  hotelsIds.forEach(element => {
    jsonHotelsIds.hotelIds.push(element.hotel_id);
  });

  return requestHandler(`${apiUrlHotel}/hotels`,jsonHotelsIds, headers);
}

async function getCategories () { //done
  return await getRequestHandler(`${apiUrlHotel}/hotels/categories`, headers);
}

async function getRoomTypesByHotel(roomType){
  return await postRequestHandler(`${apiUrlHotel}/hotels/roomtypes`, roomType, headers);
}

async function getMarkupByHotel(clientId, hotelId) {
  let payload = {};
  if (clientId && hotelId) {
    payload = { clientId: clientId, hotelId: hotelId };
  } else if (clientId) {
    payload = { clientId: clientId };
  } else if (hotelId) {
    payload = { hotelId: hotelId };
  }
  return await postRequestHandler(`${apiUrlHotel}/hotels/markups`, payload, headers);
}

async function createMarkupByHotel(clientId, hotelId, markupCLP, markupUSD) {
  const payload = {
    clientId: clientId,
    hotelId: hotelId,
    markupCLP: markupCLP,
    markupUSD: markupUSD
  };
  return await postRequestHandler(`${apiUrlHotel}/hotels/markups`, payload, headers);
}

async function deleteMarkupByHotel(clientId, hotelId) {
  const payload = {
    clientId: clientId,
    hotelId: hotelId
  };
  return await postRequestHandler(`${apiUrlHotel}/hotels/markups/delete`, payload, headers);
}



// WEBPACK FOOTER //
// ./src/utils/services/hotels/hotel.service.js